import { confirmDelete, getData } from "../helpers";

const load = (element) => {
    // console.log(element);

    element.addEventListener("click", () => {
        confirmDelete(
            getData(element, "title"),
            getData(element, "data-text"),
            getData(element, "data-url"),
            getData(element, "data-delete"),
            getData(element, "data-cancel")
        );
    });
};

class DeleteButton extends HTMLButtonElement {
    connectedCallback() {
        load(this);
    }
}

window.customElements.define("delete-button", DeleteButton, {
    extends: "button",
});
